import React, { memo, useContext } from "react";
import DeviceManagerContext from "./context";
import useMatchMedia from "./hooks/useMatchMedia";
import { default as default2 } from "./components/Desktop";
import { default as default3 } from "./components/MediaQuery";
import { default as default4 } from "./components/Mobile";
import { default as default5 } from "./context";
const DeviceManagerProvider = ({ children, ssrValue }) => {
  const viewPort = useMatchMedia(ssrValue);
  return /* @__PURE__ */ React.createElement(DeviceManagerContext.Provider, {
    value: {
      viewPort
    }
  }, children);
};
const MemDeviceManagerProvider = memo(DeviceManagerProvider);
const DeviceManager = ({
  children,
  ssrValue = void 0
}) => {
  const context = useContext(DeviceManagerContext);
  if (context) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(MemDeviceManagerProvider, {
    ssrValue
  }, children);
};
var DeviceManager_default = DeviceManager;
export {
  default2 as Desktop,
  default5 as DeviceManagerContext,
  default3 as MediaQuery,
  default4 as Mobile,
  DeviceManager_default as default
};
